import { w as writable } from "./index3.js";
const storedScore = typeof localStorage !== "undefined" ? localStorage.getItem("totalScore") : "0";
const initialScore = parseInt(storedScore) || 0;
const score = writable(initialScore);
if (typeof window !== "undefined") {
  score.subscribe((value) => {
    localStorage.setItem("totalScore", value.toString());
  });
}
